import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
export type EnqueteIndexPagePaginationFragment = { __typename?: 'OffsetBasedPageInfo', limit: number, offset: number, totalCount: number };

export const EnqueteIndexPagePaginationFragmentDoc = gql`
    fragment EnqueteIndexPagePagination on OffsetBasedPageInfo {
  limit
  offset
  totalCount
}
    `;